import { createContext } from 'react';

import { TransactionBackTarget, TransactionContextValue } from '@/context/transaction/types';

export const BACK_TARGETS: Record<TransactionBackTarget, NonNullable<TransactionContextValue['backTarget']>> = {
    payment: { label: 'Payment Settings', href: '/payment' },
    telemetry: { label: 'Telemetry', href: '/telemetry' },
    billing: { label: 'Billing History', href: '/billing' },
};

export const TransactionContext = createContext({} as TransactionContextValue);
